import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';

interface Props {
  className?: string;
  closeChangePasswordModal: () => void;
  loading?: boolean;
}

function PasswordFormActions(props: Props) {
  const { closeChangePasswordModal, loading, className } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      className={className}
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={closeChangePasswordModal}
        />,
        <Button
          buttonText={t('submit')}
          buttonType={ButtonTypes.primaryFilled}
          disabled={loading}
          fullWidth
          leftIcon="check"
          type="submit"
        />,
      ]}
    />
  );
}

export default PasswordFormActions;
